import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Mybumpie.css';
import './ReactCrop.css';
import * as actions from '../Actions';
import Cookies from "js-cookie";
// import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
// import ReactCrop from 'react-image-crop';
import UploadFrame from '../common/UploadFrame';
import UploadImgOverlay from '../common/UploadImgOverlay';
import ShareMileOverlay from '../common/ShareMileOverlay';
import Service from '../../service/Service';

const service = new Service();

class UploadBumpie extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let ContestData = [];
        let ProductData = [];

        // if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
        //     initialData = window.__initialData__['initialData'];
        //     delete window.__initialData__;
        // } else {
        //     if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
        //         initialData = props.staticContext.initialData['initialData'];
        //     }
        // }
        // if (initialData) {
        //     if (initialData['data1'] && initialData['data1']['result']) {
        //         ContestData = initialData['data1']['result'];
        //     }
        //     if (initialData['data2'] && initialData['data2']['result']) {
        //         ProductData = initialData['data2'];
        //     }
        // }
        this.state = {
            initialData: initialData,
            ContestData: ContestData,
            ProductData: ProductData,
            contestId: '',
            insertIds: [],
            tagProd: [],
            tagKids: [],
            insertProdIds: [],
            minDuedate: '',
            selectedfile: '',
            imagePreviewUrl: '',
            croppedImageUrl: '',
            Base64: '',
            cropx: '',
            cropy: '',
            cropwidth: '',
            cropheight: '',
            cropedImagePath: '',
            isMemories: '',
            isBumpieLoaded: '',
            gender: '',
            userPhoto: '',
            frameId: '',
            src: null,
            maxDuedate: '',
            IsExpected: false,
            isMemorySelected: false,
            crop: {
                x: 0,
                y: 0,
                width: 200,
                height: 200,
            },

        };
        this.isJcropFilesLoaded = false;
    }
    // static initialAction(reqUrl, ftk, authData, uId, childData) {
    //     var header = {
    //         'Content-Type': 'application/json',
    //         'ftk': ftk,
    //         'uid': uId,
    //         'access-token': authData['access-token'],
    //         'user-agent': global.userAgent,
    //         'isdesktop': global.isdesktop
    //     }
    //     let obj1 = {
    //         url: global.api_url + "contest/getactivecontestdetails",
    //         body: JSON.stringify({
    //             "type": "communitypostmemory"
    //         })
    //     };
    //     let obj2 = {
    //         url: global.api_url + "getproductfromhistory",
    //         body: JSON.stringify({
    //             'pageNo': 1,
    //             'pageSize': 15
    //         })
    //     };
    //     return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    // }
    componentDidMount() {
        if (!global.ftk || !Cookies.get('frameUrl') || Cookies.get('frameUrl') == '') {
            this.props.history.push('/tools/my-baby-bump');
        } else {
            document.addEventListener("click", this.domClick);
            this.setDateRange();
            if (Cookies.get('startweekdate') == undefined) {
                this.setState({ minDuedate: '' });
            }
            if (global.userAry['IsExpected']) {
                this.setState({
                    IsExpected: true,
                    frameId: Cookies.get('frameId'),
                    weekNumber: Cookies.get('weekNumber'),
                });
                this.setDateRange(Cookies.get('startweekdate'));
            } else {
                this.setState({
                    IsExpected: false
                });
            }
            // if (navigator.onLine) {
            //     if (!this.state.ContestData || (this.state.ContestData && this.state.ContestData.length < 1)) {
            //         service.showLoader();
            //         this.getContestData();
            //     } else {
            //         localStorage.setItem('ContestData', JSON.stringify(this.state.ContestData));
            //     }
            //     if (!this.state.ProductData || (this.state.ProductData && this.state.ProductData.length < 1)) {
            //         service.showLoader();
            //         this.getProductData();
            //     } else {
            //         localStorage.setItem('ProductData', JSON.stringify(this.state.ProductData));
            //     }
            // } else {
            //     if (localStorage.getItem('ContestData')) {
            //         this.setState({
            //             ContestData: JSON.parse(localStorage.getItem('ContestData'))
            //         });
            //     }
            //     if (localStorage.getItem('ProductData')) {
            //         this.setState({
            //             ProductData: JSON.parse(localStorage.getItem('ProductData'))
            //         });
            //     }
            //     service.hideLoader();
            // }
        }
    }
    // getContestData() {
    //     console.log("getContestData");
    //     var postData = {
    //         "type": "communitypostmemory"
    //     }
    //     var url = global.api_ci_url + "MyBumpie/getContestData";
    //     // var url= global.api_url + "contest/getactivecontestdetails";
    //     service.postServiceCall(url, postData).then((json) => {
    //         console.log("getContestData=1111=============>", json['result']);
    //         if (json['result']) {
    //             this.setState({
    //                 ContestData: json['result'],
    //             }, () => { });
    //             localStorage.setItem('ContestData', JSON.stringify(json));
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    // getProductData() {
    //     console.log("getProductData");
    //     var postData = {
    //         'pageNo': 1,
    //         'pageSize': 15
    //     }
    //     var url = global.api_ci_url + "MyBumpie/getProductData";
    //     // var url= global.api_url + "getproductfromhistory";
    //     service.postServiceCall(url, postData).then((json) => {
    //         console.log("getProductData===1111===========>", json);
    //         if (json['result']) {
    //             this.setState({
    //                 ProductData: json,
    //             }, () => { });
    //             localStorage.setItem('ProductData', JSON.stringify(json));
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    setDateRange() {
        let maxDuedate = new Date();
        let minDuedate = new Date(Cookies.get('startweekdate'));
        let year = maxDuedate.getFullYear();
        let month = maxDuedate.getMonth() + 1;
        let day = maxDuedate.getDate();
        let year1 = minDuedate.getFullYear();
        let month1 = minDuedate.getMonth() + 1;
        let day1 = minDuedate.getDate();
        month = month > 9 ? month : "0" + month;
        month1 = month1 > 9 ? month1 : "0" + month1;
        day = day > 9 ? day : "0" + day;
        this.setState({ minDuedate: year1 + '-' + month1 + '-' + day1 });
        this.setState({ maxDuedate: (year) + '-' + month + '-' + (day) });
        // this.setState({ minChilddate: (year - 14) + '-' + month + '-' + day });
        // this.setState({ maxChilddate: year + '-' + month + '-' + day });
        console.log("maxDuedate===================>", (year) + '-' + month + '-' + (day))
    }
    onKeyPressDate = (event) => {
        event.returnValue = false;
        if (event.preventDefault) event.preventDefault();
    }
    onFocusDate = (event) => {
        console.log("onFocusDate================>", event);
        var val;
        if (event.target.value && event.target.value != '') {
            val = new Date(event.target.value);
            var y = val.getFullYear();
            var m = val.getMonth() + 1;
            var d = val.getDate();
            m = m > 9 ? m : "0" + m;
            d = d > 9 ? d : "0" + d;
            var finalVal = y + '-' + m + '-' + d;
            event.target.value = finalVal;
        }
        event.target.type = "date";
        event.target.readOnly = false;
        if (event.preventDefault) event.preventDefault();
        event.target.focus();
    }
    onBlurDate = (event) => {
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        event.target.type = "text";
        event.target.readOnly = true;
        if (event.target.value && event.target.value != '') {
            let date = new Date(event.target.value);
            let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
            event.target.value = day + "-" + months[date.getMonth()] + "-" + date.getFullYear();
        }
    }
    domClick(event) {
        console.log("domClick==================================>", event.target);
        if (event.target.id == "photodesc" && event.target.nextSibling.classList) {
            console.log("domClick==================================>1");
            if (!event.target.nextSibling.classList.contains("focus-active")) {
                console.log("domClick==================================>2");
                event.target.nextSibling.classList.add("focus-active");
            } else if ("" == event.target.value && event.target.nextSibling.classList.contains("focus-active")) {
                console.log("domClick==================================>3");
                event.target.nextSibling.classList.remove("focus-active");
            }
        } else if (event.target.classList && (event.target.classList.contains('options_overlay') || event.target.classList.contains('alertMsg-overlay'))) {
            event.target.style.display = "none";
        } else {
            return false;
        }
    }
    onChange(e) {
        if (navigator.onLine) {
            var fileObj = document.getElementById("mybumpie_upload").files[0];
            console.log(fileObj);
            if (fileObj.type.includes('image')) {
                console.log("image");
                if (fileObj.type && (fileObj.type.toLowerCase() == "image/jpg" || fileObj.type.toLowerCase() == "image/jpeg" || fileObj.type.toLowerCase() == "image/png") && fileObj.size < 8388608) {
                    this.setState({ isMemorySelected: true });
                    document.getElementsByClassName('file_upload_err')[0].style.display = "none";
                    document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
                    if (this.isJcropFilesLoaded) {
                        actions.afterJcropFilesLoaded(fileObj);
                    } else {
                        var _this=this;
                        service.loadJcropFiles(_this).then(function () {
                            _this.isJcropFilesLoaded = true;
                            actions.afterJcropFilesLoaded(fileObj);
                        }).catch(function () {
                            _this.setState({ isMemorySelected: false });
                            document.getElementById("mybumpie_upload").value = null;
                            return false;
                        })
                    }
                } else {
                    document.getElementById("mybumpie_upload").value = null;
                    document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                    document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                    return false;
                }
            } else {
                document.getElementById("mybumpie_upload").value = null;
                document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                
                return false;
            }
        } else {
            document.getElementById("mybumpie_upload").value = null;
            service.showAlert("Please Check Internet Connection!!!");
        }
    }
   
    CancleButton() {
        window.scrollTo(0, 150),
        document.querySelector("#main_frame").setAttribute("src", Cookies.get("frameUrl"));
        document.querySelector('.add_photo_lbl').style.display = "block";
        document.querySelector('.upload_photo_btns').style.display = "none";
        document.querySelector('.choose_photo_btns').style.display = "block";
    }
    UploadPhoto() {
        // e.preventDefault();
        var childListData = global.userAry['childData']['UserChildList'];
        var childinfo = [];

        if (!this.state.contestId && this.state.contestId == undefined) {
            this.state.contestId = 0;
        }
        for (var i = 0; i < childListData.length; i++) {
            if (childListData) {
                if (childListData.length > 1) {
                    if (childListData[i]['IsExpected']) {
                        // childinfo =[{ 
                        //     "childId":childListData[i]['ChildId'],
                        //     "childName": childListData[i]['ChildName'],
                        //     "dob":childListData[i]['DOB'],
                        //     "gender":childListData[i]['Gender'],
                        //     "childPic": childListData[i]['childPhoto']
                        // }],
                        this.state.tagKids = [{
                            "childId": childListData[i]['ChildId'],
                            "childName": childListData[i]['ChildName'],
                            "dob": childListData[i]['DOB'],
                            "gender": childListData[i]['Gender'],
                            "childPic": childListData[i]['childPhoto'],
                            "setAsChildPic": 1
                        }];
                    }
                }
            }
        }
        console.log("uploadBumpieMemory=====================>gender", global.userAry['Sex'].toLowerCase());
        if (global.userAry['Sex'].toLowerCase() == 'male' || global.userAry['Sex'] == "Boy" || global.userAry['Sex'] == '0') {
            this.state.gender = 0;
        } else if (global.userAry['Sex'].toLowerCase() == 'female' || global.userAry['Sex'] == "Girl" || global.userAry['Sex'].toLowerCase() == '1') {
            this.state.gender = 1;
        } else if (global.userAry['Sex'].toLowerCase() == 'guardian' || global.userAry['Sex'].toLowerCase() == '2' || global.userAry['Sex'].toLowerCase() == '') {
            this.state.gender = 2;
            console.log("this.state.gender========>", this.state.gender);
        }
        if (document.querySelector(".checkAll").classList.contains("isChecked")) {
            this.state.userPhoto = document.querySelector("#main_frame").src;
        } else {
            this.state.userPhoto = global.userAry['userPhoto'];
        }
        if (this.state.ProductData != '-1') {
            var comboval = 0;
            for (var i = 0; i < this.state.ProductData.length; i++) {
                if (this.state.ProductData['productId'] == this.state.insertProdIds[i]) {
                    comboval = this.state.ProductData['isCombo'];
                    this.state.tagProd = {
                        "productId": this.state.ProductData['productId'],
                        "isActive": this.state.ProductData['isActive'],
                        "productName": this.state.ProductData['productName'],
                        "isInStock": this.state.ProductData['isInStock'],
                        "catId": this.state.ProductData['catId'],
                        "subCatId": this.state.ProductData['subCatId'],
                        "brandId": this.state.ProductData['brandId'],
                        "isCombo": comboval
                    }
                }

            }
        }
        var a = !0;
        if (document.querySelector("#main_frame").src == Cookies.get("frameUrl"))
            return document.getElementsByClassName('file_upload_err')[0].style.display = "inline-block",
                document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible",
                document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Upload Mybumpie",
                a = !1,
                !1;
        if (document.getElementsByClassName('file_upload_err')[0].style.display = "none",
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "hidden",
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "",
            // document.querySelector("#mybumpie_upload").parent().find(".file_upload_err").css("visibility", "hidden"),
            // document.querySelector("#mybumpie_upload").parent().find(".file_upload_err").html(""),
            "" == document.querySelector("#FirstDateOfLMP").value)
            return document.getElementsByClassName('bumpie_date_err')[0].style.display = "inline-block",
                document.getElementsByClassName('bumpie_date_err')[0].style.visibility = "visible",
                document.getElementsByClassName('bumpie_date_err')[0].innerHTML = "Please enter due date",
                document.querySelector('#calendar-icon').style.top="35%",
                a = !1,
                !1;
        if (document.getElementsByClassName('bumpie_date_err')[0].style.display = "none",
            document.getElementsByClassName('bumpie_date_err')[0].style.visibility = "hidden",
            document.getElementsByClassName('bumpie_date_err')[0].innerHTML = "",
            !a)
            return !1;
        this.state.isBumpieLoaded = 1;
        document.querySelector(".confirm-overlay").style.display = "block";
    }
    uploadBumpieMemory() {
        console.log("this.state.gender========>", Cookies.get('weekNumber'),Cookies.get('frameId'));
        var weekNumber,frameId;
        if(this.state.weekNumber!=undefined && Cookies.get('frameId')){
            weekNumber = this.state.weekNumber;
            frameId = Cookies.get('frameId');
        }else{
            weekNumber = Cookies.get('weekNumber');
            frameId = Cookies.get('frameId');
        }
        var postData = {
            "postType": "0",
            "desc": document.querySelector('#photodesc').value,
            "image": document.querySelector("#main_frame").src,
            "bumpieDate": document.querySelector("#FirstDateOfLMP").value,
            "frameId": frameId,
            "weekNumber": weekNumber,
            "isBumpieLoaded": 1,
            "isMemories": "1",
            "childArr": global.userAry['childData']['UserChildList'],
            "tagKids": this.state.tagKids,
            "tagProd": this.state.tagProd,
            "contestId": this.state.contestId,
            "userId": global.uID,
            "userName": global.userAry['userName'],
            "myself": document.querySelector("#setmyselfval").value,
            "setAsProfilePic": document.querySelector(".checkAll").classList.contains("isChecked"),
            "imageWidth": "450",
            "imageHeight": "450",
            "userPic": this.state.userPhoto,
            "userGender": this.state.gender
        }

        console.log("postData=======>", postData);
        var url = global.api_ci_url + "MyBumpie/uploadmemory";
        // var url = global.api_url + "uploadmemory";
        service.postServiceCall(url, postData).then((json) => {
            console.log("json===========>", json);
            if (json['result'] == "Success" && this.state.cropedImagePath != "") {
                console.log("API Responce in success image");
                Cookies.set("frameUrl", '', 1);
                document.getElementById("shareMileImg").src = this.state.cropedImagePath;
                document.getElementsByClassName("shareMile-overlay")[0].style.display = "block";
                if (window.innerWidth < 767) {
                    document.querySelector('.shareImg-container').style.left = (((window.innerWidth * 0.85) - 208) / 2) + "px";
                }
                var ischecked = document.getElementById('setpic').classList.contains("isChecked");
                if (json['result'] == "Success") {
                    if (ischecked == true) {
                        console.log("this is for UpdateUserInformation_app")
                        var postData = {
                            "EmailAddress": global.ftk,
                            "firstname": global.userAry['childData']['UserMaster'].firstname,
                            "middlename": global.userAry['childData']['UserMaster'].middlename,
                            "lastname": global.userAry['childData']['UserMaster'].lastname,
                            "pmno": global.userAry['childData']['UserMaster'].mobileno,
                            "mobileno": global.userAry['childData']['UserMaster'].mobileno,
                            "DateOfBirth": global.userAry['childData']['UserMaster'].DateOfBirth,
                            "Sex": global.userAry['childData']['UserMaster'].Sex,
                            "MaritalStatus": global.userAry['childData']['UserMaster'].MaritalStatus,
                            "AD": global.userAry['childData']['UserMaster'].AD,
                            "WalletAmount": global.userAry['childData']['UserMaster'].WalletAmount,
                            "userPhoto": this.state.cropedImagePath,
                        }
                        var url = global.api_ci_url + "Face/updateUserDetails";
                        service.postServiceCall(url, postData).then((json) => {
                            console.log("API Responce UpdateUserInformation_app" + json)
                            if (json['UpdateUserInformation_appResult'] == "true") {
                                console.log(json['UpdateUserInformation_appResult']);
                                //    this.saveUserActions(postData);

                            }
                        })
                    }
                    document.querySelector(".confirm-overlay").style.display = "none";
                    alert("Picture Uploaded sucessfully");
                } else {
                    alert("Please wait");
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error("error", error);
            service.hideLoader();
        });
    }
    saveUserActions(postData){
        let postChildParams = [];
        let childParams = [];
        let postIsExp = 0;
        let accountarr=[];
        if(this.state.isExpecting) {
            postIsExp = 1;
        }
        var childData=global.userAry['childData']['UserChildList'];
        for(var i=0;i<childData.length;i++) {
            childParams[i]["id"]=childData.ChildId;
            childParams[i]["gender"]=childData.Gender;
            childParams[i]["childdob"]=childData.DOB;
            childParams[i]["isExpecting"]=childData.IsExpected;
            childParams[i]["childname"]=childData.ChildName;
            childParams[i]["childphoto"]=childData.childPhoto;
            array_push($postChildParams,$childParams[$key]);
            postChildParams.push({
                postChildParams:childParams[i]
             })
        }
        accountarr.push({
            "user_name":postData['user_name'],
            "pic_url":postData['pic_url'],
            "user_id":global.userAry['mycid'],
            "expecting_dob":postData['expecting_dob'],
            "user_childinfo":postChildParams,
            "user_gender":postData['user_gender'],
            "isDesk":true
        })  
        // var url = global.api_ci_url + "Face/getUserActions";
        var url = global.api_ci + "getUserActions";

        service.postServiceCall(url, accountarr).then((json) => {
            console.log("Json" + json)
            
        })
    }
    okPopup() {
        console.log("isMemories", this.state.isMemories);
        this.state.isMemories = "1",
            this.uploadBumpieMemory();
    }
    canclePopup() {
        console.log("isMemories", this.state.isMemories);
        this.state.isMemories = "0",
            this.uploadBumpieMemory();
    }
    // ShopItem(i) {
    //     console.log("shopItem=====================>");
    //     var a;
    //     let t = [];
    //     if (document.querySelector(".prod_tag_" + i).classList.contains("shop-item-active")) {
    //         document.querySelector(".prod_tag_" + i).classList.remove("shop-item-active");
    //         console.log("shopItem=====================>1");
    //         t.push(i);
    //         console.log("t=====>", t)
    //     } else {
    //         console.log("shopItem=====================>2");
    //         document.querySelector(".prod_tag_" + i).classList.remove("shop-item-active");
    //         document.querySelector(".prod_tag_" + i).classList.add("shop-item-active");
    //         this.state.insertProdIds.push(i);
    //     }
    //     console.log("t.length", t.length);
    //     for (var r = 0; r < t.length; r++) {
    //         (a = this.state.insertProdIds.indexOf(t[r])) > -1 && this.state.insertProdIds.splice(a, 1);
    //         // document.querySelector("#tagProdIds").value(insertProdIds);
    //         console.log("insertProdIds=====>", this.state.insertProdIds)
    //     }
    //     console.log("insertProdIds=====>1", this.state.insertProdIds)

    // }
    shareMileCloseButton() {
        document.querySelector('.shareMile-overlay').style.display = "none";
        if (this.state.isMemories == "1") {
            this.props.history.push('/memories');
        } else {
            this.props.history.push('/tools/my-baby-bump');
        }
    }
    render() {
        return (
            <main className="main-container Mybumpie">
                <Helmet
                    title="Capture Your Baby Bump Week by Week - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "With the news of pregnancy, together come’s happiness, responsibility and your bump. Capture your every baby bump week by week while pregnant along with date & other details." }, { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>My Bumpie</span>
                    </div>
                    <h1 className="B24_00">My Bumpie (Week #{Cookies.get("weekNumber")})</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="bumpie_container upload_mybumpie">
                            {/* <input type="hidden" name="tagIds" id="tagIds" value="<?=$childinfo[0]->childId;?>">
                                <input type="hidden" name="childlen" id="childlen" value="0"> */}
                            <input type="hidden" name="contestid" id="contestid" value={this.state.contestId}/>
                            <input type="hidden" name="tagProdIds" id="tagProdIds" value="" />
                            <input type="hidden" id="setmyselfval" name="setmyselfval" value="0" />
                            <div className="photo_wrapper">
                                <div className="photo_frame">
                                    <img id="main_frame" src={Cookies.get("frameUrl")} alt={Cookies.get("frameUrl")} title={Cookies.get("frameUrl")}  data-id={Cookies.get("frameId")}/>
                                    <label className="add_photo_lbl" htmlFor="mybumpie_upload" >
                                        <span className="R15_9e add_photo">
                                            <span data-icon-font="x" className="icon"></span>
                                                Upload Photo
                                            </span>
                                    </label>
                                    <input type="file" name="mybumpie_upload" id="mybumpie_upload" className="mybumpie_upload" accept="image/*" onChange={(e) => this.onChange(e)} style={{ 'display': 'none' }} />
                                </div>
                                <div className="file_upload_err"></div>
                            </div>
                            <div id="test_append"></div>
                            <div className="content_wrapper">
                                <div className="duedate-firstdate duedate-tool">
                                    <div className="M17_9e">My Bumpie Date</div>
                                    <label htmlFor="FirstDateOfLMP">
                                        <input id="FirstDateOfLMP" className="rm_inp duedate-datepicker R17_42" type="text" name="FirstDateOfLMP" placeholder="Select Date" readOnly onKeyPress={(e) => this.onKeyPressDate(e)} onFocus={(e) => this.onFocusDate(e)} onBlur={(e) => this.onBlurDate(e)} min={this.state.minDuedate} max={this.state.maxDuedate} />
                                        <span className="icon calendar-icon" id="calendar-icon" data-icon-font="w"></span>
                                        <div className="bumpie_date_err"></div>
                                    </label>
                                </div>
                                <UploadFrame eleRef={this}  tool={"MB"}/>
                            </div>

                        </div>
                    </div>

                    <UploadImgOverlay eleRef={this} tool={"MB"}/>
                    {/* <!-- Confirm box popup start --> */}
                    <div className="confirm-overlay">
                        <div className="confirm-popup">
                            <span className="popup-msg">Do you like to share your Bumpie Images to memories ?</span>
                            <div className="popup-btns">
                                <span className="confirm-ok" onClick={() => { this.okPopup() }}>OK</span>
                                <span className="confirm-cancle" onClick={() => { this.canclePopup() }}>CANCEL</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--shareMile popup starts-->  */}
                <ShareMileOverlay eleRef={this} tool={"MB"}/>
                {/* <!--shareMile popup ends-->   */}
                <Right url={this.props.match.url} />
            </main>
        )

    }
}

export default UploadBumpie;


// WEBPACK FOOTER //
// src/shared/tools/Mybumpie/UploadBumpie.js